// Bug real (auditoría 2026-08-16): la firma era posicional (equation, gender, weight, age,
// creatinine, unit) pero el único caller (EHR.js) siempre invoca con un objeto de opciones —
// "equation" terminaba recibiendo el objeto completo y "creatinine" quedaba undefined, así
// que el guard de abajo cortaba siempre: la columna CrCl del panel renal mostraba placeholder
// para TODOS los pacientes, sin ningún error visible.
export const getClCr = ({ equation, gender, weight, age, creatinine, unit }) => {
  let result;

  if (!creatinine) return;

  let _creatinine = +creatinine

  if (unit === "µmol/L") {
    _creatinine = _creatinine / 88.4
  }

  let _gender = gender?.toString()?.trim()?.toLowerCase()?.[0]
  // Bug real (auditoría 2026-08-16): gender ausente/desconocido asumía 'm' (masculino) en
  // silencio, sin ninguna señal de que se hizo una suposición — para dosificación renal esto
  // es una asunción clínica real, no un detalle de UX. Ahora se corta y se devuelve un flag
  // explícito en vez de adivinar el sexo del paciente.
  if (!_gender) return { value: null, warning: 'no_gender' }

  if (!Number.isInteger(age)) return

  if (equation === "cogau" && weight) {
    let f1 = 140 - age;
    let f2 = f1 * weight;
    let f3 = 72 * _creatinine;
    result = f2 / f3;
    if (_gender === "f") {
      result *= 0.85;
    }
  }

  if (equation === "mdrd") {
    let f1 = Math.pow(_creatinine, -1.154);
    let f2 = Math.pow(age, -0.203);
    result = 175 * f1 * f2;
    if (_gender === "f") {
      result *= 0.742;
    }
  }

  if (equation === "ckd") {
    let [f1, f2] = _gender === 'f' ? [0.7, 144] : [0.9, 141]
    let f3 = Math.pow(0.993, age);
    let f4 = _creatinine / f1;
    let f5 = Math.pow(f4, -1.209)
    if (_gender === "m" && _creatinine <= f1) {
      f5 = Math.pow(f4, -0.411);
    } else if (_gender === "f" && _creatinine <= f1) {
      f5 = Math.pow(f4, -0.329);
    }

    result = f2 * f5 * f3
  }

  if (!result?.toFixed) return

  return { value: result.toFixed(2), um: 'mil/min' };
}

export const getBMI = (height, weight) => {
  if (!height || !weight) return;

  const h2 = Math.pow(height / 100, 2);
  const value = weight / h2;

  // Bug real (auditoría 2026-08-16): el corte clínico estándar de "bajo peso" es IMC < 18.5,
  // no < 18 — un paciente con IMC entre 18.0 y 18.49 quedaba mal clasificado como "normal".
  if (value < 18.5) return { value, warning: "underweight", class: 'text-warning' };
  if (value <= 25) return { value, warning: "normal", class: 'text-success' };
  if (value < 30) return { value, warning: "overweight", class: 'text-warning' };

  return { value, warning: "obese", class: 'text-danger' };
}
